import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ label, value, status, icon, description, change, trend }) => {
  const getStatusColor = (status) => {
    const colors = {
      healthy: 'text-success',
      warning: 'text-warning',
      critical: 'text-error'
    };
    return colors?.[status] || 'text-muted-foreground';
  };

  const getStatusIcon = (status) => {
    const icons = {
      healthy: 'CheckCircle2',
      warning: 'AlertTriangle',
      critical: 'XCircle'
    };
    return icons?.[status] || 'Info';
  };

  const getTrendColor = (trend) => {
    if (trend === 'up' && (label?.includes('Response') || label?.includes('Query'))) {
      return 'text-error';
    }
    if (trend === 'down' && (label?.includes('Response') || label?.includes('Query'))) {
      return 'text-success';
    }
    return trend === 'up' ? 'text-success' : 'text-error';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-primary/10">
          <Icon name={icon} size={24} className="text-primary" />
        </div>
        <Icon
          name={getStatusIcon(status)}
          size={20}
          className={getStatusColor(status)}
        />
      </div>
      <p className="text-2xl font-bold mb-1 text-data">{value}</p>
      <p className="text-sm font-medium mb-1">{label}</p>
      <div className="flex items-center justify-between">
        <p className="text-xs text-muted-foreground">{description}</p>
        {change && (
          <span className={`text-xs font-medium ${getTrendColor(trend)}`}>
            {change}
          </span>
        )}
      </div>
    </div>
  );
};

export default MetricCard;